import { Construction } from 'lucide-react';
import { useI18nTranslation } from '../../lib/use-i18n-translation';

export interface ComingSoonPageProps {
  titleKey: string;
  descriptionKey: string;
  phase: number;
}

/** Stand-in for the modules that arrive in later phases; keeps the router and nav honest today. */
export const ComingSoonPage = ({ titleKey, descriptionKey, phase }: ComingSoonPageProps) => {
  const { t } = useI18nTranslation();

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-foreground">{t(titleKey)}</h1>

      <div className="flex items-start gap-4 rounded-lg border border-border bg-card p-6">
        <Construction className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
        <div>
          <p className="text-sm font-medium text-card-foreground">{t('placeholder.comingSoon')}</p>
          <p className="mt-1 text-sm text-muted-foreground">{t(descriptionKey)}</p>
          <p className="mt-3 text-xs text-muted-foreground">{t('placeholder.phase', { phase })}</p>
        </div>
      </div>
    </div>
  );
};
